module.exports = __webpack_public_path__ + "img/tools.7aaa6682.svg";